<template>
  <layout title="Ebook" :transparent="true" class="overflow-x-hidden">
    <div class="w-full -mt-20 pt-20 bg-primary-dark" style="z-index: -1">
      <div
        class="relative md:mt-16 px-8 py-8 mx-auto xl:px-5 max-w-6xl md:px-6 lg:pt-10 lg:pb-28 flex gap-10 flex-col md:flex-row"
      >
        <div class="flex-1">
          <h1
            class="text-3xl font-extrabold leading-9 tracking-tight text-white sm:text-4xl sm:leading-10 text-center sm:text-left"
          >
            {{ ebook.title }}
          </h1>
          <p class="mt-6 text-xl leading-7 text-white">
            {{ ebook.description }}
          </p>
        </div>
        <div class="flex-1 shadow-allArround bg-white rounded-xl p-10 h-full">
          <div>
            <p class="mb-2 text-base font-bold text-center">
              Enter your details below to download your copy of the guide.
            </p>

            <form @submit.prevent="submitForm" method="POST">
              <div class="grid grid-cols- sm:grid-cols-2 gap-6 mt-6">
                <div>
                  <label
                    for="firstName"
                    class="block text-sm font-medium leading-5 text-gray-700"
                    >First Name</label
                  >
                  <div class="mt-1 rounded-md shadow-sm">
                    <input
                      id="firstName"
                      type="text"
                      name="firstName"
                      v-model="form.firstName"
                      placeholder="First name"
                      required
                      class="w-full"
                      autofocus
                    />
                  </div>

                  <div class="error" v-if="errors.firstName">
                    {{ errors.firstName }}
                  </div>
                </div>
                <div>
                  <label
                    for="lastName"
                    class="block text-sm font-medium leading-5 text-gray-700"
                    >Last Name</label
                  >
                  <div class="mt-1 rounded-md shadow-sm">
                    <input
                      id="lastName"
                      type="text"
                      name="lastName"
                      v-model="form.lastName"
                      placeholder="Last name"
                      required
                      class="w-full"
                      autofocus
                    />
                  </div>

                  <div class="error" v-if="errors.lastName">
                    {{ errors.lastName }}
                  </div>
                </div>
              </div>

              <div class="mt-6">
                <label
                  for="message"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  Company
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="companyName"
                    type="text"
                    name="companyName"
                    v-model="form.companyName"
                    placeholder="Company name"
                    required
                    class="w-full"
                    rows="2"
                  />
                </div>
                <div class="error" v-if="errors.companyName">
                  {{ errors.companyName }}
                </div>
              </div>

              <div class="mt-6">
                <label
                  for="jobTitle"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  Job Title
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="jobTitle"
                    type="text"
                    name="jobTitle"
                    placeholder="Job Title"
                    v-model="form.jobTitle"
                    class="w-full"
                    rows="2"
                    required
                  />
                </div>
                <div class="error" v-if="errors.jobTitle">
                  {{ errors.jobTitle }}
                </div>
              </div>

              <div class="mt-6">
                <label
                  for="businessEmail"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  Business Email
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="businessEmail"
                    type="email"
                    name="businessEmail"
                    placeholder="Business email"
                    v-model="form.businessEmail"
                    required
                    class="w-full"
                    rows="2"
                  />
                </div>

                <div class="error" v-if="errors.businessEmail">
                  {{ errors.businessEmail }}
                </div>
              </div>

              <p class="mt-6 text-sm font-medium text-gray-700 text-left">
                By submitting this form, you confirm that you have read and
                understand our
                <a
                  class="link"
                  href="https://www.youverse.id/privacy-policy"
                  target="_blank"
                  >Privacy Policy</a
                >.
              </p>

              <div class="mt-6">
                <span class="block w-full rounded-md shadow-sm">
                  <button type="submit" class="btn-primary w-full">
                    Submit
                  </button>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");

export default {
  props: {
    errors: Object,
  },
  components: { layout },

  data() {
    return {
      form: {
        firstName: null,
        lastName: null,
        companyName: null,
        businessEmail: null,
        jobTitle: null,
        slug: this.$page.props.ebook.slug,
      },
      showForm: true,
      ebook: this.$page.props.ebook,
    };
  },
  methods: {
    submitForm() {
      this.$inertia.post("/ebook-email", this.form, {
        preserveScroll: true,
        onSuccess: (e) => {
          if (e.props.flash.message != null) {
            this.$store.commit("showFlashMessage", {
              message: e.props.flash.message,
              type: e.props.flash.message_type,
            });
          }

          if (e.props.flash.message_type === "success" ) {
            dataLayer.push({ event: "submit_form_ebook_download" });
            this.form.firstName = null;
            this.form.lastName = null;
            this.form.companyName = null;
            this.form.jobTitle = null;
            this.form.businessEmail = null;
          }
        },
      });
    },
  },
};
</script>
